import React from "react";
import {
  Table,
  TableBody,
  TableContainer,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { WheelCategories } from "./WheelsTab";
import { getLoggedInUser } from "../../../../utils/helpers";
import TableHeader from "./ListViewComponents/TableHeader";
import WheelTableRow from "./ListViewComponents/WheelTableRow";

const getDateColumnLabel = (tabType) => {
  switch (tabType) {
    case WheelCategories.Created:
      return "Date Created";
    case WheelCategories.Cloned:
      return "Date Cloned";
    case WheelCategories.Unlocked:
      return "Date Unlocked";
    case WheelCategories.Favourited:
      return "Date Favorited";
    default:
      return "Date Created";
  }
};

const ListView = ({
  wheels = [],
  tabType = WheelCategories.Created,
  customMenuItems = [],
  isInsideFolder = false,
  excludeMenuItems = [],
  onWheelDelete,
  onWheelReactivate,
}) => {
  const nav = useNavigate();

  const columnHeaders = [
    { id: "wheel", label: "Wheel", width: "35%", paddingLeft: true },
    { id: "privacy", label: "Privacy", width: "20%" },
    { id: "type", label: "Type", width: "12%" },
    { id: "size", label: "Size", width: "12%" },
    { id: "dateEdited", label: getDateColumnLabel(tabType), width: "16%" },
    { id: "actions", label: "Actions", width: "5%" },
  ];

  const processText = (htmlText) => {
    let cleanedText = htmlText?.replace(/<\/?[^>]+(>|$)/g, "");
    cleanedText = cleanedText?.trim();
    if (cleanedText?.length > 49)
      cleanedText = `${cleanedText.slice(0, 49)}....`;
    return cleanedText || "";
  };

  const formatDate = (isoDateString) => {
    const date = new Date(isoDateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  const processWheelData = (data) => {
    const wheelUpdatedData = [...data?.wheel_segments]?.map((obj) => ({
      ...obj,
    }));

    return wheelUpdatedData.sort((a, b) => a.position - b.position);
  };

  const handleRedirection = (data) => {
    const viewPath =
      data?.version === 2 ? `/wheel/${data?.id}` : `/wheelView/${data?.id}`;
    nav(viewPath);
  };

  return (
    <TableContainer sx={{ overflow: "hidden" }}>
      <Table>
        <TableHeader columnHeaders={columnHeaders} />
        <TableBody>
          {wheels?.length > 0 &&
            wheels.map((data, index) => (
              <WheelTableRow
                key={index}
                data={data}
                tabType={tabType}
                handleRedirection={handleRedirection}
                formatDate={formatDate}
                processText={processText}
                processWheelData={processWheelData}
                isInsideFolder={isInsideFolder}
                customMenuItems={customMenuItems}
                excludeMenuItems={excludeMenuItems}
                onWheelDelete={onWheelDelete}
                onReactivate={onWheelReactivate}
              />
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ListView;
